import { render, staticRenderFns } from "./BasicsDesc.vue?vue&type=template&id=d86b77f6"
import script from "./BasicsDesc.vue?vue&type=script&lang=js"
export * from "./BasicsDesc.vue?vue&type=script&lang=js"
import style0 from "./BasicsDesc.vue?vue&type=style&index=0&id=d86b77f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports